module.exports = __webpack_public_path__ + "static/img/loading.f9153708.gif";